import React from 'react';
import { ISingleSelectButtonProps, ISelectOptionItemType } from '../type';

const FilterSelectButton = (props: ISingleSelectButtonProps) => {
  const { selectedOption, placeholder, name } = props || {};

  const renderSelected = (selectedOption: ISelectOptionItemType) => {
    const { icon, text } = selectedOption || {};
    // 统一有图标则展示到选择框内
    return (
      <span className="db-single-select-button-value">
        {selectedOption?.icon && <img src={icon} />} <span>{text}</span>
      </span>
    );
  };

  return (
    <div
      className={`db-single-select-button`}
    >
      <span className="db-single-select-button-text">
        {name ? name : ''}
      </span>
      {selectedOption ? renderSelected(selectedOption) :(
        <div className='db-single-select-button-placeholder' >{placeholder}</div>
      )}
    </div>
  );
};

export default FilterSelectButton;
